import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';

import spring from 'react-motion/lib/spring';

import { Icon }  from 'mastodon/components/icon';

import Motion from '../../ui/util/optional_motion';
import { UploadFileIcon } from 'mastodon/components/icons/upload_file';

export const UploadProgress = ({ active, progress, isProcessing, mediaType }) => {
  // Don't show progress for images
  if (!active || mediaType === 'image') {
    return null;
  }

  let message;
  let icon;

  if (isProcessing) {
    message = <FormattedMessage id='upload_progress.processing' defaultMessage='Processing…' />;
    icon = 'spinner';
  } else {
    message = <FormattedMessage id='upload_progress.label' defaultMessage='Uploading…' />;
    icon = 'upload';
  }

  return (
    <div className='upload-progress'>
      <Icon id={icon} icon={UploadFileIcon} />

      <div className='upload-progress__message'>
        {message}

        <div className='upload-progress__backdrop'>
          <Motion defaultStyle={{ width: 0 }} style={{ width: spring(progress) }}>
            {({ width }) =>
              <div className='upload-progress__tracker' style={{ width: `${width}%` }} />
            }
          </Motion>
        </div>
      </div>
    </div>
  );
};

UploadProgress.propTypes = {
  active: PropTypes.bool,
  progress: PropTypes.number,
  isProcessing: PropTypes.bool,
  mediaType: PropTypes.string,
};
